<script setup lang="ts">
import type { IDataViewTableProps } from './DataView.types'

defineProps<IDataViewTableProps>()

const hasFormattedDate = (item: Record<string, unknown>): item is Record<string, unknown> & { formattedDate: { date: string; hour: string } } => {
  return item && typeof item === 'object' && 'formattedDate' in item && item.formattedDate !== null && typeof item.formattedDate === 'object'
}

const hasFormattedLink = (item: Record<string, unknown>): item is Record<string, unknown> & { formattedLink: { url: string; text: string }; title: string } => {
  return item && typeof item === 'object' && 'formattedLink' in item && item.formattedLink !== null && typeof item.formattedLink === 'object'
}
</script>

<template>
  <UiTable
    :columns="columns"
    :items="items"
    variant="fullWidth"
    class="dataViewTable"
  >
    <template #cell-date="{ item }">
      <p
        v-if="hasFormattedDate(item)"
        class="dataViewTable__date"
      >
        {{ item.formattedDate.date }}<br>
        <small>{{ item.formattedDate.hour }}</small>
      </p>

      <p
        v-else-if="item.date"
        class="dataViewTable__date"
      >
        {{ item.date }}
      </p>
    </template>

    <template #cell-report="{ item }">
      <p class="dataViewTable__title">
        {{ item.title }}
      </p>

      <UiButton
        v-if="hasFormattedLink(item) && item.formattedLink.url && item.formattedLink.text"
        class="dataViewTable__link"
        size="small"
        variant="secondary"
        :to="item.formattedLink.url"
      >
        {{ $t(item.formattedLink.text) }}
      </UiButton>
    </template>
  </UiTable>
</template>

<style lang="scss" scoped>
.dataViewTable {
  &__title {
    @include body-2;
    margin-bottom: 1.2rem;
    color: $text-400;
  }

  &__date {
    @include body-2-medium;
    color: $text-400;

    small {
      @include body-2;
    }
  }

  &__link {
    &::after {
      content: '';
      width: 1.6rem;
      height: 1.6rem;
      margin-left: 0.8rem;
      background-image: url('/icons/icn_arrow_right.svg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
  }
}
</style>
